import { render, staticRenderFns } from "./EditNation.vue?vue&type=template&id=9ae5d5b2&"
import script from "./EditNation.vue?vue&type=script&lang=js&"
export * from "./EditNation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports